import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CardComponent } from './card.component';

@NgModule({
  imports: [CardComponent, CommonModule],
  exports: [CardComponent],
})
export class CardModule {}
